import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { uploaded_respondent_loading : true, uploaded_respondent_data: '', uploaded_respondent_error_data : '', uploaded_respondent_error: false};

export function uploadRespondent(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_UPLOAD_RESPONDENT_API:
        return {
            uploaded_respondent_loading: true,
            uploaded_respondent_data: '',
            uploaded_respondent_error_data: '',
            uploaded_respondent_error: false
        };
      case organisationConstants.RECIEVE_UPLOAD_RESPONDENT_API:
        return {
            uploaded_respondent_loading: false,
            uploaded_respondent_data: action.uploaded_respondent.data,
            uploaded_respondent_error_data: '',
            uploaded_respondent_error: false
        };
      case organisationConstants.ERROR_UPLOAD_RESPONDENT_API:
        return { 
            uploaded_respondent_loading: false,
            uploaded_respondent_data: '',
            uploaded_respondent_error_data: action.error.response.data.message,
            uploaded_respondent_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/uploadCsv/uploadRespondent.reducer.js